module.exports = {
    phoneType: ['Main', 'Work', 'Mobile', 'Home', 'Other'],
    emailType: ['Main', 'Work', 'Personal', 'Other'],
    contactTitle: ['Mr.', 'Mrs.', 'Ms.', 'Miss'],
}